import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import ImageCompressor from 'image-compressor.js';
import SvgIcon from '@material-ui/core/SvgIcon';
import {FormattedMessage, injectIntl} from 'react-intl';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FileAttach from '../../../../components/FileAttach';
import {isStudent} from '../../../../utils/userUtility';
import Camera from '../../../../assets/images/photo';
import CircularLoader from '../../../../components/CircularLoader';
import StudioReadOnlyMessage from '../StudioReadOnlyMessage';
import LessonOwner from './LessonOwner';

@injectIntl
@inject('looperStore', 'projectStore', 'appStore')
@observer
class TaskContainer extends Component {
    modules = {
        toolbar: [
            [{header: []}],
            ['bold', 'italic', 'underline'],
            ['image', 'code-block']
        ],
        clipboard: {
            matchVisual: false,
        }
    };

    onChangeName = (e) => {
        this.props.looperStore.setProjectName(e.target.value);
    };

    onImageChange = async (files) => {
        const imageCompressor = new ImageCompressor();
        try {
            const compressedFile = await imageCompressor.compress(files[0], {quality: 0.8, maxWidth: 800, maxHeight: 600});
            this.props.projectStore.saveLessonBackground(compressedFile, true);
        } catch (e) {
            console.log(e);
        }
    };

    onImageError = () => {
        this.props.appStore.createAlertFromMessageId('warning', 'notifications.unsupportedFormats');
    };

    onDescriptionChange = (content, delta, source) => {
        if (source === 'user') {
            this.props.looperStore.setProjectDescription(content);
        }
    };

    render() {
        const {isReadOnly, previewMode, looperStore, projectStore, intl: {formatMessage: translate}} = this.props;
        const {loopedProject, showAssignment, assignmentAvatar, assignmentName} = looperStore;

        return (
            <div className="m-studio-task">
                {isReadOnly && <Fragment>
                    <StudioReadOnlyMessage/>
                    <LessonOwner
                        label="studio.task.ownerLabel"
                        name={loopedProject.owner.name}
                        avatar={loopedProject.owner.avatar}
                    />
                </Fragment>}
                {!isReadOnly && showAssignment && <LessonOwner
                    label="studio.task.assignmentLabel"
                    name={assignmentName}
                    avatar={assignmentAvatar}
                />}
                <div className="m-studio-form">
                    <div className="m-form-label"><FormattedMessage id="studio.task.nameLabel" /></div>
                    <div className="m-form-wrapper">
                        <input
                            className="input"
                            readOnly={previewMode || isReadOnly}
                            placeholder={translate({id: 'createLesson.titlePlaceholder'})}
                            value={(loopedProject.name === 'Untitled Lesson') ? '' : loopedProject.name}
                            onChange={this.onChangeName}
                        />
                        <div className="image">
                            {loopedProject.backgroundImg && <img width="73" height="40" src={loopedProject.backgroundImg} alt=""/>}
                            {(!previewMode && !isReadOnly) && <FileAttach
                                className="change-image-btn"
                                onError={this.onImageError}
                                onChange={this.onImageChange}
                                fileExtension="image/*">
                                {projectStore.isSavingBackground
                                    ? <CircularLoader thickness={5} color="inherit" size={15} />
                                    : <SvgIcon viewBox="0 0 20 20">{Camera}</SvgIcon>
                                }
                            </FileAttach>}
                        </div>
                    </div>
                    <div className="m-form-label"><FormattedMessage id="studio.task.descriptionLabel" /></div>
                    {(previewMode || isReadOnly) ?
                        <div className="m-studio-quill">
                            <div className="ql-container">
                                <div className="ql-editor" dangerouslySetInnerHTML={{__html: loopedProject.description}}/>
                            </div>
                        </div>
                        : <ReactQuill
                            className="m-studio-quill"
                            modules={this.modules}
                            value={loopedProject.description || ''}
                            placeholder={translate({id: `createLesson.editor${isStudent() ? 'Student' : 'Teacher'}Placeholder`})}
                            onChange={this.onDescriptionChange}/>
                    }
                </div>
            </div>
        );
    }
}

export default TaskContainer;
